module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Inter-Thin-bc0c400ab97641432db27b3541daa5ac.woff2";